import 'jquery';

export class Breakpoints {
    constructor() {
        this._smMin = 768;
        this._mdMin = 992;
        this._lgMin = 1200;
        this._xlMin = 1440;
    }
    isXs(viewportWidth) {
        viewportWidth = viewportWidth || $(window).width();
        return viewportWidth < this._smMin;
    }

    isSmDown(viewportWidth) {
        viewportWidth = viewportWidth || $(window).width();
        return viewportWidth < this._mdMin;
    }

    isMdDown(viewportWidth) {
        viewportWidth = viewportWidth || $(window).width();
        return viewportWidth < this._lgMin;
    }

    isLgDown(viewportWidth) {
        viewportWidth = viewportWidth || $(window).width();
        return viewportWidth < this._xlMin;
    }

    isSmUp(viewportWidth) {
        viewportWidth = viewportWidth || $(window).width();
        return viewportWidth >= this._smMin;
    }

    isMdUp(viewportWidth) {
        viewportWidth = viewportWidth || $(window).width();
        return viewportWidth >= this._mdMin;
    }

    isLgUp(viewportWidth) {
        viewportWidth = viewportWidth || $(window).width();
        return viewportWidth >= this._lgMin;
    }

    isXl(viewportWidth) {
        viewportWidth = viewportWidth || $(window).width();
        return viewportWidth >= this._xlMin;
    }
}